
import XButton from 'vux/src/components/x-button/index.vue'
import dateFormat from 'vux/src/tools/date/format.js'
import Group from 'vux/src/components/group/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import PopupRadio from 'vux/src/components/popup-radio/index.vue'

import {fetch,promptMessage } from '@/api/dataHandling';
import {getken} from '@/api/getToken';
import {urlConfig} from '@/api/urlConfig';
export default {

data(){
return {
submitTxt:'提 交',
dateValue:'',
timeValue:'',
disabledIf:false,
orderItemId:'ff80808165ad5fde0165b269b4db64a5',
datelist:[],
timelist:[],
}
},
components: {
XButton,
Group,
PopupPicker,
PopupRadio
},
methods: {

dateHide () {
this.getTime();
},
submit(){
this.$store.commit('updateLoadingStatus',{isLoading:true});
if(this.dateValue != '' && this.timeValue != '' ){
this.disabledIf = true;
this.paramsData = new URLSearchParams();
this.paramsData.append('personInfoId',this.personInfoId);
this.paramsData.append('orderClass','50001');
this.paramsData.append('orderDate',this.dateValue);
this.paramsData.append('timeStepId',this.timeValue);
this.paramsData.append('area','82c90aee002f80810c77');
fetch('post',urlConfig.VIPreservationSure,this.paramsData).then(response => {
this.disabledIf =true;
this.$store.commit('updateLoadingStatus',{isLoading:false});
promptMessage('提示','预约成功！')

}).catch(error => {
this.disabledIf =true;
promptMessage('提示','预约失败！' + error);
})

}else {
promptMessage('提示','提交失败，还有选项未选择！')
}
},
getUserId(){
fetch('get',urlConfig.GetSfzh + '?openid='+this.$route.query.openid).then(response => {
this.getPersonInfoId(response.sfzh);

}).catch(error => {

})
},
getPersonInfoId(sfzh){
fetch('get',urlConfig.GetPersonInfoId + '?sfzh='+sfzh).then(response => {
this.personInfoId = response.personInfoId;
this.getDate();

}).catch(error => {
})
},
getDate(){
this.paramsDate = new URLSearchParams();
this.paramsDate.append('personInfoId',this.personInfoId);
this.paramsDate.append('orderItemId',this.orderItemId);
fetch('post',urlConfig.VIPreservationDetDate,this.paramsDate).then(response => {
this.datelist = response;
this.$store.commit('updateLoadingStatus',{isLoading:false});

}).catch(error => {
this.disabledIf =true;
this.submitTxt = '不能提交，'+ error;
this.$store.commit('updateLoadingStatus',{isLoading:false})
})
},
getTime(){
this.$store.commit('updateLoadingStatus',{isLoading:true});
this.timelist = [];
this.timeValue = '';
this.paramsTime = new URLSearchParams();
this.paramsTime.append('orderDate',this.dateValue);
this.paramsTime.append('orderItemId',this.orderItemId);
fetch('post',urlConfig.VIPreservationDetTime,this.paramsTime).then(response => {
for(let i =0;i<response.length;i++){
this.timelist.push({value:response[i].canOrderNum,key:response[i].scheTimeId});
}
this.$store.commit('updateLoadingStatus',{isLoading:false});

}).catch(error => {
})
},
timeClick(){
if(this.dateValue == ''){
promptMessage('提示','请先选择预约日期！');
}
}
},
mounted(){
getken(this.getUserId);
this.$store.commit('updateLoadingStatus',{isLoading:true})
}
}



// WEBPACK FOOTER //
// ./src/project/vipnotifyProject/vipAppointment.vue